import Vue from "vue";
import VueRouter from "vue-router";
import { noGuardRoutes, routes } from "@/router/routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name !== undefined && noGuardRoutes.includes(to.name)) {
    next();
  } else {
    Vue.$cookies.get("jkt") ? next() : next({ name: "login" });
  }
});

export default router;
